// Copied CLI commands are always scoped to the org and project the page shows (ui-spec §3.3), because the CLI
// otherwise resolves both from its active context and could act on same-named objects elsewhere.

export interface CliScope {
  org: string;
  /** Absent for org-scoped kinds, which get `--org` only. */
  project?: string;
}

export interface CliOptions {
  /** Account › Appearance "Omit -p/--org in copied commands". */
  omitScope?: boolean;
  /** Arguments after `--` (the command run by exec or run). */
  trailing?: string[];
}

const SAFE = /^[A-Za-z0-9_./:=@%+,-]+$/;

/** POSIX-shell quoting: safe words stay bare, everything else is single-quoted. */
export function shellQuote(word: string): string {
  if (word !== "" && SAFE.test(word)) return word;
  return `'${word.replace(/'/g, `'\\''`)}'`;
}

export function scopeFlags(scope: CliScope): string[] {
  return scope.project ? ["-p", scope.project, "--org", scope.org] : ["--org", scope.org];
}

/** `nodus describe job/lora-fine-tune -p research --org acme`. */
export function cliCommand(args: string[], scope: CliScope, options: CliOptions = {}): string {
  const words = ["nodus", ...args, ...(options.omitScope ? [] : scopeFlags(scope))];
  let out = words.map(shellQuote).join(" ");
  if (options.trailing?.length) out += ` -- ${options.trailing.map(shellQuote).join(" ")}`;
  return out;
}

/** The label selectors of a list view as `-l k=v` flags, for the list page's Copy CLI. */
export function selectorFlags(labels: Record<string, string>): string[] {
  return Object.entries(labels).flatMap(([k, v]) => ["-l", `${k}=${v}`]);
}
